import React, { Component } from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { toggleAddProgrammePopup, toggleNotification } from '../../redux/reducers/view';
import { getUserProgramsFullRequest } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import * as serviceWorker from '../../serviceWorker';


import AvatarCirce from '../AvatarCircle';

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon } from 'mdbreact';
import { connectedUsersRequest } from '../../redux/reducers/connectedUsers';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { systemRequest } from '../../redux/reducers/system';

class UpdatePopup extends Component {
  state = {
    modal: true
  };
  render() {
    return (
      // <Dialog
      //   open={true}
      //   onClose = {handleCloseNow}
      //   aria-labelledby="alert-dialog-title"
      //   aria-describedby="alert-dialog-description"
      //   classes={{paper:classes.dialogPaper}}
      // >
      //   <div style={{backgroundColor:'white', padding:8}}>
      //     <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
      //     Please enter the code of the program you would like to add</DialogTitle>
      //     <DialogContent className={classes.dialogContent}>
      //       <AddCodeForm/>
      //     </DialogContent>
      //   </div>
      // </Dialog>
      <MDBContainer>
        <MDBModal isOpen={true}  centered >
          <MDBModalHeader id="alert-dialog-title" className="secondary-color m-1" > <div className="dialogHeader">Update Alert</div></MDBModalHeader>
          <MDBModalBody>
             There is a new version available. Please click "UPDATE" to install
          <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{this.props.loading && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={this.props.handleUpdate}>Update</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
    }
  }

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});

const mapStateToProps = state => ({
  system: state.systemReducer.system,
  loading: state.systemReducer.fetching
});
const mapDispatchToProps = dispatch => ({
  systemRequest: () => dispatch(systemRequest())
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('showSystemAlert', 'toggleShowSystemAlert', false),
  withHandlers({
    handleUpdate: props => async () => {
      try {
        // Best-effort unregister using CRA helper
        await serviceWorker.unregister();
      } catch (e) {}
      try {
        // Unregister any remaining SWs
        if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
          const regs = await navigator.serviceWorker.getRegistrations();
          await Promise.all(regs.map(r => r.unregister()));
        }
      } catch (e) {}
      try {
        // Clear runtime caches so the new build is fetched fresh
        if (window.caches && caches.keys) {
          const names = await caches.keys();
          await Promise.all(names.map(n => caches.delete(n)));
        }
      } catch (e) {}
      // Navigate with a cache-busting query to ensure fresh assets
      const base = (process.env.REACT_APP_MY_VAR || window.location.origin).replace(/\/$/, '');
      const target = `${base}/student?_=${Date.now()}`;
      window.location.replace(target);
     }
  }),
  lifecycle({
    componentWillUnmount() {
      //this.props.getUserProgramsFullRequest();
    },
    componentWillReceiveProps(nextProps){
      
    }
  }),
  withStyles(styles),
)(UpdatePopup);

UpdatePopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};
